export default {
    nav: {
        // 顶部栏
        vision: 'ETAO INNOVATION',
        walk: 'Walk ETAO',
        product: 'Product',
        case: ' Case',
        introduce: 'Introduce',
        recruitment: 'Recruitment',
        contact: 'Contact us',
        // 底部栏
        company: "",
        telephone: 'Telephone',
        phone: 'Phone',
        email: 'Email',
        shenzhen: '',
        suzhou: '',
    },
    home: {
        // 首页
        who: "Who's ETAO  ",
        about: "",
        about2: '',
        industry: "",
        wms: "",
        wms_system: "",
        mes: "",
        mes_system: "",
        npm: "",
        npm_system: "",
        iiot: "",
        iiot_system: "",
        npi: "",
        npi_system: ""
    },
    product: {
        // 产品中心
        wms: {
            choose: "",
            time: "",
            detailed: "",
            print: "",
            print_detailed: "",
            link: "",
            link_detailed: "",
            data: "",
            data_detailed: "",
            modular: "",
            modular_detailed: "",
            flexible: "",
            flexible_detailed: "",
            architecture: "",
            architecture_detailed: " ",
            features: "",
            features_detailed: "",
        },
        mes: {
            choose: "",
            time: "",
            detailed: "",
            print: "",
            print_detailed: "",
            link: "",
            link_detailed: "",
            data: "",
            data_detailed: "",
            modular: "",
            modular_detailed: "",
            flexible: "",
            flexible_detailed: "",
            architecture: "",
            architecture_detailed: " ",
            features: "",
            features_detailed: "",
        },
        npm: {
            choose: "",
            time: "",
            detailed: "",
            print: "",
            print_detailed: "",
            link: "",
            link_detailed: "",
            data: "",
            data_detailed: " ",
            modular: "",
            modular_detailed: "",
            flexible: "",
            flexible_detailed: "",
            architecture: "",
            architecture_detailed: " ",
            establish: "",
            smart: "",
            solve: "",
            curing: "",
        },
        iiot: {
            choose: "",
            time: "",
            detailed: "",
            print: "",
            print_detailed: "",
            link: "",
            link_detailed: "",
            data: "",
            data_detailed: "",
            modular: "",
            modular_detailed: "",
            flexible: "",
            flexible_detailed: "",
            architecture: "",
            architecture_detailed: " ",
            features: "",
            features_detailed: "",
        },
        npi: {
            choose: " ",
            time: "",
            detailed: "",
            print: "",
            print_detailed: "",
            link: "",
            link_detailed: " ",
            data: "",
            data_detailed: " ",
            modular: "",
            modular_detailed: "",
            flexible: "",
            flexible_detailed: "",
            architecture: "",
            architecture_detailed: "",
            features: ""

        },
    },
    case: {
        // 客户案例
        haoen: {
            name: "",
            business: "",
            title: "",
            details: "",
            module: "",
            wms: "",
            mes: " ",
            qms: "",
            iot: "",
            cloud: "",
        },
        huayang: {
            name: "",
            details: "",
            iot: "",
            emis: "",
        },
        zhuoao: {
            name: "",
            business: "",
            details: "",
            mes: "",
            iot: "",
            itm: ""
        },
        changcheng: {
            name: "",
            business: "",
            details: "",
            kbs: "",
            iot: "",
            npi: ""
        },
        huarong: {
            name: "",
            business: "",
            details: "",
            details2: "",
            wms: "",
            mes: "",
            qms: "",
            iot: "",
            huawei: ""
        },
        kangyuan: {
            name: "",
            details: " ",
            iot: ""
        },
        weixin: {
            name: "",
            business: "",
            details: " ",
            iot:"",
            emis: "",
        },
        hainengda: {
            name: "",
            business: "",
            details: "",
            iot: "",
            mes: "",
            npi:""
        },
    },
    introduce: {
        // 公司介绍
        about:"",
        about2:"",
        vision:"",
        etao:"",
        technology_title:"",
        technology:"",
        invent:"",
        emis:"",
        course:"",
        certificate:"",
    },
    recruitment: {
        // 人才招聘
        looking:"",
        java_engineer:{
            java:"",
            jobs:"",
            duties:"",
            duties2:"",
            duties3:"",
            duties4:" ",
            duties5:"",
            require: "",
            require_details: "",
            require_details2: "",
            require_details3: "",
            require_details4: "",
            require_details5: "",
            require_details6: ""
        },
        project_engineer:{
            project:"",
            duties: "",
            duties2: "",
            duties3: "",
            duties4: "",
            duties5: "",
            require_details: "",
            require_details2: "",
            require_details3: "",
            require_details4: "",
            require_details5: "",
            require_details6: "",
            require_details7: ""
        },
        product_manager:{
            product:"",
            duties: "",
            duties2: "",
            duties3: "",
            duties4: "",
            duties5: "",
            require_details: "",
            require_details2: "",
            require_details3: "",
            require_details4: "",
            require_details5: "",
        },
        product_assistant:{
            assistant:"",
            duties: "",
            duties2: " ",
            duties3: "",
            require_details: "",
            require_details2: "",
            require_details3: "",
            require_details4: "",
            require_details5: " ",
        },
        project_manager:{
            project:"",
            duties: "",
            duties2: " ",
            duties3: "",
            duties4: "",
            duties5: "",
            require_details: "",
            require_details2: "",
            require_details3: "",
            require_details4: "",
            require_details5: "",
        },
        internship_work:{
            internship:"",
            duties: "",
            duties2: " ",
            duties3: "",
            duties4: "",
            require_details: "",
            require_details2: "",
            require_details3: "",
        },
        recruitment:{
            title:"",
            delivery:"",
            interview:"",
        }
    },
    contact: {
        // 联系我们
        title:"",
        company:" ",
        call:"",
        address:"",
        consulting:"",
        email:"",
        code:""
    }
}
